import { log } from "./log";
import { client } from "./supabase";

// Lectura/escritura de `alertas_recurrencia_descartadas` (migración
// supabase/migrations/20260925d_alertas_recurrencia_descartadas.sql, ESCRITA SIN APLICAR — 10.137).
// Mientras la tabla no exista, `cargarDescartes` devuelve `null` (no `[]`, que sería indistinguible
// de "tabla vacía") y el caller (AlertasRecurrenciaBanner) usa eso para NO mostrar el botón de
// descartar — las otras 3 formas de apagado (cierre/abierta este año, actividad de CRM) siguen
// funcionando igual. Un error real (no "tabla no existe") también cae acá y se loguea (10.170) en
// vez de romper el banner del Home (10.177).

export const cargarDescartes = async ({ pais }) => {
  const { data, error } = await client
    .from("alertas_recurrencia_descartadas")
    .select("empresa_norm, mes, ano")
    .eq("pais", pais);
  if (error) {
    log.warn("cargarDescartes", `alertas_recurrencia_descartadas no disponible todavía: ${error.message}`);
    return null;
  }
  return data || [];
};

export const descartarAlerta = async ({ pais, empresaNorm, mes, ano, usuarioId }) => {
  const { error } = await client
    .from("alertas_recurrencia_descartadas")
    .insert({ pais, empresa_norm: empresaNorm, mes, ano, descartado_por: usuarioId });
  if (error) {
    log.error("descartarAlerta", error);
    throw error;
  }
};
